import styles from "./companyreview.module.scss";

type ReviewImageProps = {
  src: string;
  name: string;
  position: string;
};

const ReviewImage: React.FC<ReviewImageProps> = ({ src, name, position }) => {
  return (
    <div className={styles.reviewData}>
      <div className={styles.imageContainer}>
        <img src={src} alt="Customer avatar" />
      </div>
      <p className={styles.name}>{name} </p>
      <p className={styles.position}>{position}</p>
    </div>
  );
};

export default ReviewImage;
